import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

export const Icon = ({ ...props }) => (
  <CustomIcon {...props} />
)

const CustomIcon = styled(FontAwesomeIcon)`
  ${({ onClick }) => (onClick ? `
    cursor: pointer;
  ` : '')}
`
